export default "__VITE_ASSET__DwZh_EBl__"